import React from 'react'
import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import { Switch } from "react-router-dom";
import { authorizationService } from 'services/common-services/authorization-service';
import IntegrationEapConfigurationMaster from './IntegrationEapConfigurationMaster/IntegrationEapConfigurationMaster';
import { INTEGRATION_EAP_CONFIGURATION_MASTER_ROUTE } from 'config/route-consts';

function IntegrationEapConfigurationView() {
    const { auth } = authorizationService.useAuthorizedRoute();
    return (
      <Switch>
        <ProtectedRoute
          path={INTEGRATION_EAP_CONFIGURATION_MASTER_ROUTE}
          key={INTEGRATION_EAP_CONFIGURATION_MASTER_ROUTE}
          component={IntegrationEapConfigurationMaster}
          auth={auth(INTEGRATION_EAP_CONFIGURATION_MASTER_ROUTE)}
        />
      </Switch>
    );
}

export { IntegrationEapConfigurationMaster };
export default IntegrationEapConfigurationView;